module.exports = __webpack_public_path__ + "img/到货通知.6bea3a99.svg";